// Extending From
import { RESTAdapter } from '@warp-drive/legacy/adapter/rest';
// External Imports
import config from 'linced-enrolments/config/environment';

// The API's error body, e.g. `{ code: 404, error: 'Not Found', message: '...' }`.
interface ApiErrorPayload {
  code?: number;
  error: string;
  message: string;
}

function isApiErrorPayload(payload: unknown): payload is ApiErrorPayload {
  return (
    typeof payload === 'object' &&
    payload !== null &&
    'error' in payload &&
    'message' in payload &&
    Boolean(payload.error) &&
    Boolean(payload.message)
  );
}

export default class Application extends RESTAdapter {
  host = config.APP.apiHost;
  namespace = config.APP.apiPath;

  // Set by subclasses: the payload key for an empty 200 response.
  declare modelNamePlural?: string;

  handleResponse(...args: Parameters<RESTAdapter['handleResponse']>) {
    const [status, , body] = args;
    if (status === 200 && Object.getOwnPropertyNames(body).length === 0) {
      // We got a 200 but with no results (body is an empty object literal)
      const plural = this.modelNamePlural;
      if (plural) {
        return { [plural]: [] };
      }
    }
    return super.handleResponse(...args);
  }

  normalizeErrorResponse(
    ...args: Parameters<RESTAdapter['normalizeErrorResponse']>
  ) {
    const [, , payload] = args;
    if (isApiErrorPayload(payload)) {
      return [
        {
          status: payload.code ?? null,
          title: payload.error,
          detail: payload.message,
        },
      ];
    }
    return super.normalizeErrorResponse(...args);
  }
}
